import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '@/components/home/DashGlobal'
import DashTenant from '@/components/home/DashTenant'
import AdminPages from '@/components/admin/AdminPages'
import ChangePassword from '@/components/admin/ChangePassword'
import XmlRepositorie from '@/components/control/XmlRepositorie'
import Auth from '@/components/auth/Auth'
import AccountPlan from '@/components/financial/AccountPlan'
import CostCenter from '@/components/financial/CostCenter'
import OperationsLevelOne from '@/components/financial/OperationsLevelOne'
import ConditionPaymentReceipt from '@/components/financial/ConditionPaymentReceipt'
import SettlementForm from '@/components/financial/SettlementForm'
import Retention from '@/components/financial/Retention'
import TypeDocument from '@/components/financial/TypeDocument'
import Tax from '@/components/financial/Tax'
import HeritageMark from '@/components/maint/HeritageMark'
import AccountCash from '@/components/financial/AccountCash'
import AccountBank from '@/components/financial/AccountBank'
import AccountCreditCard from '@/components/financial/AccountCreditCard'
import GroupPatrimonial from '@/components/maint/GroupPatrimonial'
import EntitySearch from '@/components/control/EntitySearch'
import ReleaseSearch from '@/components/financial/ReleaseSearch'
import RecordRelease from '@/components/financial/RecordRelease'
import TypeRelease from '@/components/financial/TypeRelease'
import AccountingEntrySearch from '@/components/financial/AccountingEntrySearch'
import ReleasePaymentReceipt from '@/components/financial/ReleasePaymentReceipt'
import DocumentSettlementSearch from '@/components/financial/DocumentSettlementSearch'
import DirectOperationSearch from '@/components/financial/DirectOperationSearch'
import RecordDirectOperation from '@/components/financial/RecordDirectOperation'
import RecordAccountingLot from '@/components/financial/RecordAccountingLot'
import FinancialCashFlowSearch from '@/components/financial/FinancialCashFlow'
import FinancialOperationSearch from '@/components/financial/FinancialOperation'
import ControlRetention from '@/components/financial/ControlRetention'
import ControlCreditCard from '@/components/financial/ControlCreditCard'
import GroupItem from '@/components/stock/GroupItem'
import ItemSearch from '@/components/stock/ItemSearch'
import UnitMeasure from '@/components/stock/UnitMeasure'
import RecordItem from '@/components/stock/RecordItem'
import RecordTypeRelease from '@/components/financial/RecordTypeRelease'
import DocumentEntrySearch from '@/components/stock/DocumentEntrySearch'
import PurchaseRequisitionSearch from '@/components/stock/PurchaseRequisitionSearch'
import RecordPurchaseRequisition from '@/components/stock/RecordPurchaseRequisition'
import RecordDocumentEntry from '@/components/stock/RecordDocumentEntry'
import PurchaseCollectionSearch from '@/components/stock/PurchaseCollectionSearch'
import RecordPurchaseCollection from '@/components/stock/RecordPurchaseCollection'
import AccountingLotSearch from '@/components/financial/AccountingLotSearch'
import OwnerSearch from '@/components/control/OwnerSearch'
import OwnerContractSearch from '@/components/control/OwnerContractSearch'
import TenantAgreementSearch from '@/components/control/TenantAgreementSearch'
import TenantSearch from '@/components/control/TenantSearch'
import RealStateSearch from '@/components/control/RealStateSearch'
import ServiceProviderSearch from '@/components/control/ServiceProviderSearch'
import ServiceRequestSearch from '@/components/control/ServiceRequestSearch'
import ServiceContractSearch from '@/components/control/ServiceContractSearch'
import OrderServiceSearch from '@/components/control/OrderServiceSearch'
import ServiceProviderContractSearch from '@/components/control/ServiceProviderContractSearch'
import RegistrationPages from '@/components/control/RegistrationPages'
import TaskSearch from '@/components/control/TaskSearch'
import MyTask from '@/components/control/MyTask'
import InvoiceSearch from '@/components/control/InvoiceSearch'
import FinancialControlSearch from '@/components/control/FinancialControlSearch'
import OpenServiceOrderSearch from '@/components/control/OpenServiceOrderSearch'
import DashProviderService from '@/components/control/DashProviderService'
import TenantFinancial from '@/components/tenant/TenantFinancial'
import TenantContract from '@/components/tenant/TenantContract'
import BusinessOpportunityOpen from '@/components/parther/BusinessOpportunityOpen'
import BusinessOpportunityClosed from '@/components/parther/BusinessOpportunityClosed'
import PartherSearch from '@/components/control/PartherSearch'
import BusinessOpportunity from '@/components/control/BusinessOpportunity'
import WarningMessage from '@/components/control/WarningMessage'
import DailyActivitieSearch from '@/components/control/DailyActivitieSearch'
import DailyActivitieUser from '@/components/parther/DailyActivitieUser'




import {
    userKey
} from '@/global'

Vue.use(VueRouter)

const routes = [
    {
        name: 'home',
        path: '/',
        component: Home
    },
    {
        name: 'DashTenant',
        path: '/dashtenant',
        component: DashTenant
    },
    {
        name: 'adminPages',
        path: '/admin',
        component: AdminPages,
        meta: {
            requiresAdmin: true
        }
    },
    {
        name: 'XmlRepositorie',
        path: '/xmlrepositories',
        component: XmlRepositorie
    },
   
    {
        name: 'auth',
        path: '/auth',
        component: Auth
    },  
    {
        name: 'AccountPlan',
        path: '/accountplans',
        component: AccountPlan
    },
    {
        name: 'CostCenter',
        path: '/costcenters',
        component: CostCenter
    },
    {
        name: 'OperationsLevelOne',
        path: '/operationslevelones',
        component: OperationsLevelOne
    },
    {
        name: 'ConditionPaymentReceipt',
        path: '/conditionpaymentreceipts',
        component: ConditionPaymentReceipt
    },
    {
        name: 'SettlementForm',
        path: '/settlementforms',
        component: SettlementForm
    },
    {
        name: 'Retention',
        path: '/retentions',
        component: Retention
    },
    {
        name: 'TypeDocument',
        path: '/typedocuments',
        component: TypeDocument
    },
    {
        name: 'UnitMeasure',
        path: '/unitmeasures',
        component: UnitMeasure
    },
    {
        name: 'Tax',
        path: '/taxs',
        component: Tax
    },
    {
        name: 'HeritageMark',
        path: '/heritagemarks',
        component: HeritageMark
    },
    {
        name: 'AccountCash',
        path: '/accountcashs',
        component: AccountCash
    },
    {
        name: 'AccountBank',
        path: '/accountbanks',
        component: AccountBank
    },
    {
        name: 'AccountCreditCard',
        path: '/accountcreditcards',
        component: AccountCreditCard
    },
    {
        name: 'GroupPatrimonial',
        path: '/grouppatrimonials',
        component: GroupPatrimonial
    },
    {
        name: 'EntitySearch',
        path: '/entitys',
        component: EntitySearch
    },
    {
        name: 'TypeRelease',
        path: '/typereleases',
        component: TypeRelease
    },
    {
        name: 'ReleaseSearch',
        path: '/registreleases',
        component: ReleaseSearch
    },
    {
        name: 'DirectOperationSearch',
        path: '/directoperationsearchs',
        component: DirectOperationSearch
    },
    {
        name: 'RecordDirectOperation',
        path: '/directoperations/',
        component: RecordDirectOperation
    },
    {
        name: 'ReleasePaymentReceipt',
        path: '/registreleasespaymentreceipts',
        component: ReleasePaymentReceipt
    },
    {
        name: 'AccountingEntrySearch',
        path: '/accountingentrys',
        component: AccountingEntrySearch
    },
    {
        name: 'DocumentSettlementSearch',
        path: '/documentsettelements',
        component: DocumentSettlementSearch
    },
    {
        name: 'Recordrelease',
        path: '/releases/',
        component: RecordRelease
    },
    {
        name: 'GroupItem',
        path: '/groupitems',
        component: GroupItem
    },
    {
        name: 'itemSearch',
        path: '/groupitems/:id/items',
        component: ItemSearch
    },
    {
        name: 'recordItem',
        path: '/items/:id',
        component: RecordItem
    },
    {
        name: 'RecordTypeRelease',
        path: '/typerelease/:id',
        component: RecordTypeRelease
    },
    {
        name: 'DocumentEntrySearch',
        path: '/documententrysearch/',
        component: DocumentEntrySearch
    },
    {
        name: 'ControlRetention',
        path: '/controlretentions/',
        component: ControlRetention
    },
    {
        name: 'ControlCreditCard',
        path: '/controlcreditcards/',
        component: ControlCreditCard
    },
    {
        name: 'RecordDocumentEntry',
        path: '/documententrys',
        component: RecordDocumentEntry
    },
    {
        name: 'FinancialCashFlowSearch',
        path: '/financialcashflows',
        component: FinancialCashFlowSearch
    },
    {
        name: 'FinancialOperationSearch',
        path: '/financialoperations',
        component: FinancialOperationSearch
    },
    {
        name: 'AccountingLotSearch',
        path: '/accountinglots',
        component: AccountingLotSearch
    },
    {
        name: 'RecordAccountingLot',
        path: '/recordaccountinglot/',
        component: RecordAccountingLot
    },
    {
        name: 'PurchaseRequisitionSearch',
        path: '/purchaserequisitions',
        component: PurchaseRequisitionSearch
    },
    {
        name: 'RecordPurchaseRequisition',
        path: '/recordpurchaserequisition/',
        component: RecordPurchaseRequisition
    },
    {
        name: 'PurchaseCollectionSearch',
        path: '/purchasecollections',
        component: PurchaseCollectionSearch
    },
    {
        name: 'RecordPurchaseCollection',
        path: '/recordpurchaseCollection/?',
        component: RecordPurchaseCollection
    },
    {
        name: 'OwnerSearch',
        path: '/owners',
        component: OwnerSearch
    },
    {
        name: 'OwnerContractSearch',
        path: '/ownercontracts',
        component: OwnerContractSearch
    },
    {
        name: 'TenantAgreementSearch',
        path: '/tenantagreements',
        component: TenantAgreementSearch
    },
    {
        name: 'TenantSearch',
        path: '/tenants',
        component: TenantSearch
    },
    {
        name: 'InvoiceSearch',
        path: '/invoices',
        component: InvoiceSearch
    },
    {
        name: 'FinancialControlSearch',
        path: '/financialcontrols',
        component: FinancialControlSearch
    },
    {
        name: 'ServiceProviderSearch',
        path: '/serviceproviders',
        component: ServiceProviderSearch
    },
    {
        name: 'ServiceRequestSearch',
        path: '/servicerequests',
        component: ServiceRequestSearch
    },
    {
        name: 'ServiceContractSearch',
        path: '/servicecontracts',
        component: ServiceContractSearch
    },
    {
        name: 'OrderServiceSearch',
        path: '/orderservices',
        component: OrderServiceSearch
    },
    {
        name: 'OpenServiceOrderSearch',
        path: '/openserviceorders',
        component: OpenServiceOrderSearch
    },
    {
        name: 'ServiceProviderContractSearch',
        path: '/serviceprovidercontracts',
        component: ServiceProviderContractSearch
    },
    {
        name: 'RealStateSearch',
        path: '/realstates',
        component: RealStateSearch
    },
    {
        name: 'TaskSearch',
        path: '/tasks',
        component: TaskSearch
    },
    {
        name: 'RegistrationPages',
        path: '/registrationpages',
        component: RegistrationPages
    },
    {
        name: 'RegistrationPages',
        path: '/registrationpages',
        component: RegistrationPages
    },
    {
        name: 'DashProviderService',
        path: '/dashproviderservice',
        component: DashProviderService
    },
    {
        name: 'ChangePassword',
        path: '/changepassword',
        component: ChangePassword
    },
    {
        name: 'TenantFinancial',
        path: '/tenantfinancial',
        component: TenantFinancial
    },
    {
        name: 'TenantContract',
        path: '/tenantcontract',
        component: TenantContract
    },
    {
        name: 'PartherSearch',
        path: '/parthers',
        component: PartherSearch
    },
    {
        name: 'BusinessOpportunity',
        path: '/businessopportunitys',
        component: BusinessOpportunity
    },
    {
        name: 'BusinessOpportunityOpen',
        path: '/businessopportunityopen',
        component: BusinessOpportunityOpen
    },
    {
        name: 'BusinessOpportunityClosedty',
        path: '/businessopportunityclosed',
        component: BusinessOpportunityClosed
    },
    {
        name: 'WarningMessage',
        path: '/warningmessages',
        component: WarningMessage
    },
    {
        name: 'MyTask',
        path: '/mytasks',
        component: MyTask
    },
    {
        name: 'DailyActivitieSearch',
        path: '/dailyactivities',
        component: DailyActivitieSearch
    },
    {
        name: 'DailyActivitieUser',
        path: '/dailyactivitiesusers',
        component: DailyActivitieUser
    },

]

const router = new VueRouter({
    mode: 'history',
    routes
})

router.beforeEach((to, from, next) => {
        const json = localStorage.getItem(userKey)
        if (to.matched.some(record => record.meta.requiresAdmin)) {
            const user = JSON.parse(json)
            user && user.admin || user.super ? next() : next({
                path: '/'
            })
        } else {
            next()
        }
    }

)


export default router